import React, { useEffect, useState } from "react";
import {
    useGetCompleteOnboardWorkshopDataQuery,
    useGetOnboardWorkshopDataQuery,
    useOnboardWorkshopMutation,
    useUpdateWorkshopMutation,
} from "../../../Services/vehicle/Vehicle";
import axios from "axios";
import useThemeColors from "../ThemeColors";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput
} from '@mui/material';
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Loader } from "react-bootstrap-typeahead";

const WorkshopInfo = () => {

    const [workshopInfoData, setWorkshopData] = useState<any>({})
    const [nameValue, setNameValue] = useState("");
    const [addressValue, setAddressValue] = useState("");
    const [cityValue, setCityValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [countryValue, setCountryValue] = useState("");
    const [pincodeValue, setPincodeValue] = useState("");
    const [startTimeValue, setStartTimeValue] = useState("");
    const [adminNameValue, setAdminNameValue] = useState("");
    const [adminUsernameValue, setAdminUsernameValue] = useState("");
    const [endTimeValue, setEndTimeValue] = useState("");
    const [adminEmailValue, setAdminEmailValue] = useState("");
    const [adminPhoneValue, setAdminPhoneValue] = useState("");
    const [escalationPhoneValue, setEscalationPhoneValue] = useState("");
    const [storedWOrkshopData, setStoreWorkshopData] = useState([]);
    const [image, setImage] = useState<any>("");
    const [gstNumber, setGstNumber] = useState("");
      const [selectedHolidays, setSelectedHolidays] = useState<any>([]);
      const [ischangeImageButtonClicked, setIsChangeImageButtonClicked] = useState(false)
      const [loader, setloader] = useState(false)
      const [responseData, setResponseData] = useState('')




      useEffect(() => {
  if (workshopInfoData?.holiday) {
    const holidaysArray = workshopInfoData.holiday.split(',').map(day => day.trim());
    setSelectedHolidays(holidaysArray);
  }
}, [workshopInfoData]);

      useEffect(() => {
        if (workshopInfoData) {
            setNameValue(workshopInfoData?.workshopName)
            setAddressValue(workshopInfoData?.address)
            setCityValue(workshopInfoData?.city)
            setStateValue(workshopInfoData?.state)
            setCountryValue(workshopInfoData?.country)
            setPincodeValue(workshopInfoData?.pincode)
            setStartTimeValue(workshopInfoData?.startTime)
            setEndTimeValue(workshopInfoData?.endTime)
            setAdminNameValue(workshopInfoData?.workShopAdministrationName)
            setAdminUsernameValue(workshopInfoData?.workShopAdministrationUserName)
            setAdminEmailValue(workshopInfoData?.workShopAdministrationEmail)
            setAdminPhoneValue(workshopInfoData?.workShopAdministrationPhoneNumber)
            setEscalationPhoneValue(workshopInfoData?.EscalationNumber)
            setImage(workshopInfoData?.workshopImage)
            setGstNumber(workshopInfoData?.gstNumber)

        }

      }, [workshopInfoData])

        const location = useLocation();
        const pathSegments = location?.pathname.split('/');
      
        const workshopIndex = pathSegments.indexOf('workshop-listed');
      
        // Get the next segment (the number) after "workshop-listed"
        const workshopId = workshopIndex !== -1 ? pathSegments[workshopIndex + 1] : null;
      
        const {data: wokshopInfo} = useGetCompleteOnboardWorkshopDataQuery(workshopId)

        const [updateWorkshopTrigger, {status}] = useUpdateWorkshopMutation()


        useEffect(() => {
            if (status === "pending") {
                setloader(true)

            }
            else {
                setloader(false)
            }

        }, [status])
      
        useEffect(() => {
          if (wokshopInfo) {
              setWorkshopData(wokshopInfo)
      
          }
      
        }, [wokshopInfo])


    const { data: workshopData } = useGetOnboardWorkshopDataQuery(1);

        const holidaysList = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

    const {
        selectedColor,
        selectedBackgroundColor,
        selectedBorderColor,
        selectedButtonBackgoundColors,
        selectedButtonColors,
    } = useThemeColors();

    useEffect(() => {
        if (workshopData) {
            setStoreWorkshopData(workshopData?.results);
        }
    }, [workshopData]);

  

    const imageHandler = (e) => {
        setIsChangeImageButtonClicked(true)
        const file = e.target.files[0];
        console.log(file, "filesdcs")
        if (file) {
            setImage(file);
        }
    };


const handleChange = (event) => {
  const {
    target: { value },
  } = event;

  setSelectedHolidays(
    typeof value === 'string' ? value.split(',') : value
  );
};

const rejectHandler  = async() => {

    //  const address = `${pincodeValue}, ${cityValue}, ${stateValue}, ${countryValue}`;
    //     const { latitude, longitude } = await fetchLatLngFromAddress(address);

        // const formData = new FormData();
        // formData.append("workshopName", nameValue);
        // formData.append("address", addressValue);
        // formData.append("city", cityValue);
        // formData.append("state", stateValue);
        // formData.append("country", countryValue);
        // formData.append("pincode", pincodeValue);
        // formData.append("startTime", startTimeValue);
        // formData.append("endTime", endTimeValue);
        // // formData.append("latitude", latitude.toString());
        // // formData.append("longitude", longitude.toString());
        // formData.append("workShopAdministrationName", adminNameValue);
        // formData.append("workShopAdministrationUserName", adminUsernameValue);
        // formData.append("workShopAdministrationEmail", adminEmailValue);
        // formData.append("workShopAdministrationPhoneNumber", adminPhoneValue);
        // formData.append("EscalationNumber", escalationPhoneValue);
        // formData.append("holiday", selectedHolidays.join(',')); 
        // formData.append("gstNumber", gstNumber);
        // formData.append("status", "rejected")

        // if (image) {
        //     formData.append("workshopImage", image);
        // }

        const rejectHandlerPayload = {
            status: "rejected",
            is_active: "false"
        }

       const response =  await updateWorkshopTrigger({id: workshopId, body: rejectHandlerPayload});

    


       try {
        if (response?.data) {
            toast.warning("Workshop rejected")

        }
        else if ("data" in response?.error) {
           const errorData = response.error.data as Record<string, string[]>;

    const phoneError = errorData["workShopAdministrationPhoneNumber"]?.[0];
    const escalationError = errorData["EscalationNumber"]?.[0];
    const escalationEmail = errorData["workShopAdministrationEmail"]?.[0]

    if (phoneError) {
        toast.error(phoneError);
    }

    if (escalationError) {
        toast.error(escalationError);
    }
      if (escalationEmail) {
        toast.error(escalationEmail);
    }


        }
        
       } catch (error) {
        toast.error("An error occured while onboarding the workshop")
        
       }

}


console.log(responseData === "approved", "sdcdcsdcsc")
const onboardWorkshophandler = async () => {
   
     
        const formData = {
            status: "approved",
            is_active: "true"
        }

       const response =  await updateWorkshopTrigger({id: workshopId, body: formData});


       try {
        if (response?.data) {
            console.log(response?.data, "repsosnsnssn")
            toast.success("Workshop Approved successfully")
            setResponseData(response?.data?.status)

        }
        else if ("data" in response?.error) {
            // console.log(response?.error?.data as {workshopImage: string[]}, "responsnsn")
           const errorData = response.error.data as Record<string, string[]>;

    const phoneError = errorData["workShopAdministrationPhoneNumber"]?.[0];
    const escalationError = errorData["EscalationNumber"]?.[0];
    const escalationEmail = errorData["workShopAdministrationEmail"]?.[0]
    const workshopImage = errorData["workshopImage"]?.[0]

    if (phoneError) {
        toast.error(phoneError);
    }

    if (escalationError) {
        toast.error(escalationError);
    }
      if (escalationEmail) {
        toast.error(escalationEmail);
    }

    if (workshopImage) {
        toast.error(workshopImage)

    }

        }
        
       } catch (error) {
        toast.error("An error occured while onboarding the workshop")
        
       }
   
};

// useEffect(() => {
//   if (workshopInfoData?.workshopImage && !ischangeImageButtonClicked) {
//     fetch(workshopInfoData?.workshopImage)
//       .then(res => res.blob())
//       .then(blob => {
//         const file = new File([blob], "existing_image.jpg", { type: blob.type });
//         setImage(file);
//       });
//   }
// }, [workshopInfoData?.workshopImage, ischangeImageButtonClicked]);

    return (
        <div
            style={{
                background: "white",
                height: "80%",
                boxShadow: `${selectedColor}80 0px 2px 10px 2px`,
                borderRadius: "40px",
            }}
        >
            <div
                style={{
                    borderBottom: "1px solid #bfbfbf",
                    fontSize: "20px",
                    padding: "15px 25px",
                    paddingBottom: "5px",
                    color: "#626262",
                    marginBottom: "20px",
                }}
            >
                Add Workshop
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    height: "100%",
                    padding: "10px 20px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        gap: "5px",
                    }}
                >
                    <label
                        className="required"
                        style={{
                            fontSize: "15px",
                            color: "#626262",
                            font: "caption",
                            padding: "0 10px",
                        }}
                    >
                        Name of the Workshop
                    </label>
                    <input
                    disabled
                        placeholder="Workshop name..."
                        value={nameValue}
                        onChange={(e) => setNameValue(e.target.value)}
                        style={{
                            borderRadius: "24px",
                            padding: "10px",
                            border: "0.5px solid #BFBFBF",
                            background: "rgb(248, 233, 227)",
                        }}
                    />
                </div>
                {/* Address */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        gap: "5px",
                    }}
                >
                    <label
                        className="required"
                        style={{
                            fontSize: "15px",
                            color: "#626262",
                            font: "caption",
                            padding: "0 10px",
                        }}
                    >
                        Address
                    </label>
                    <input
                    disabled

                        placeholder="Address..."
                        value={addressValue}
                        onChange={(e) => setAddressValue(e.target.value)}
                        style={{
                            borderRadius: "24px",
                            padding: "10px",
                            border: "0.5px solid #BFBFBF",
                            background: "rgb(248, 233, 227)",
                        }}
                    />
                </div>
                {/* Codes */}
                <div
                    style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            City
                        </label>
                        <input
                    disabled

                            placeholder="City..."
                            value={cityValue}
                            onChange={(e) => setCityValue(e.target.value)}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            State
                        </label>
                        <input
                    disabled

                            placeholder="State..."
                            value={stateValue}
                            onChange={(e) => setStateValue(e.target.value)}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            PIN Code
                        </label>
                        <input
                    disabled

                            placeholder="PIN code..."
                            value={pincodeValue}
                            onChange={(e) => setPincodeValue(e.target.value)}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Country
                        </label>
                        <input
                    disabled

                            placeholder="Country..."
                            value={countryValue}
                            onChange={(e) => setCountryValue(e.target.value)}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                </div>
                <div style={{display: "flex", width: "100%", alignItems:"center", gap:"20px"}}>

                <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                    <label>GST Number</label>
                    <input   value={gstNumber} onChange={(e) => setGstNumber(e.target.value)}
                    disabled

                        style={{
                            borderRadius: "24px",
                            padding: "10px",
                            border: "0.5px solid #BFBFBF",
                            background: "rgb(248, 233, 227)",
                        }}
                    />
                </div>

               <FormControl fullWidth>
  <label>Holidays</label>
  <Select
    multiple
                    disabled

    value={selectedHolidays}
    onChange={handleChange}
    input={<OutlinedInput />}
    renderValue={(selected) => selected.join(', ')}
    style={{height: "45px"}}

    // style={{ background: "rgb(248, 233, 227)" }}
  >
    {holidaysList.map((day) => (
      <MenuItem key={day} value={day}>
        <Checkbox checked={selectedHolidays.includes(day)} />
        <ListItemText primary={day} />
      </MenuItem>
    ))}
  </Select>
</FormControl>


                </div>


                {/* Codes End */}

                {/* WOrking hours start */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <div>
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                                fontWeight: "600",
                            }}
                        >
                            Working hours
                        </label>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "10px",
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                gap: "10px",
                            }}
                        >
                            <label
                                className="required"
                                style={{
                                    fontSize: "15px",
                                    color: "#626262",
                                    font: "caption",
                                    padding: "0 5px",
                                }}
                            >
                                Start time
                            </label>
                            <input
                    disabled

                                type="time"
                                value={startTimeValue}
                                onChange={(e) =>
                                    setStartTimeValue(e.target.value)
                                }
                                style={{
                                    borderRadius: "24px",
                                    padding: "10px",
                                    border: "0.5px solid #BFBFBF",
                                    background: "rgb(248, 233, 227)",
                                }}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                gap: "5px",
                            }}
                        >
                            <label
                                className="required"
                                style={{
                                    fontSize: "15px",
                                    color: "#626262",
                                    font: "caption",
                                    padding: "0 10px",
                                }}
                            >
                                End time
                            </label>
                            <input
                    disabled

                                type="time"
                                value={endTimeValue}
                                onChange={(e) =>
                                    setEndTimeValue(e.target.value)
                                }
                                style={{
                                    borderRadius: "24px",
                                    padding: "10px",
                                    border: "0.5px solid #BFBFBF",
                                    background: "rgb(248, 233, 227)",
                                }}
                            />
                        </div>
                    </div>
                </div>
                {/* WOrking hrs end */}

                {/* Workshop image */}
                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        gap: "20px",
                        flexDirection: "column",
                    }}
                >
                    <label
                        className="required"
                        style={{
                            fontSize: "15px",
                            color: "#626262",
                            font: "caption",
                            padding: "0 10px",
                        }}
                    >
                        Workshop Image
                    </label>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        <div
                            style={{
                                // border: "1px solid black",
                                // borderStyle: "dotted",
                                // height: "43px",
                                width: "200px",
                            }}
                        >

    
{/* {!ischangeImageButtonClicked  ? 
<>
                             {image && (
                                <img
                                    src={image}
                                    alt="preview"
                                    width={200}
                                    height={200}
                                />
                            )} 
                            </>
                            :

                            <> */}
                               {image && (
                                <img
    src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                    alt="preview"
                                    width={200}
                                    height={200}
                                />
                            )}
                            {/* </>
} */}

                        </div>
                        {/* <label
                            htmlFor="upload-logo"
                            style={{
                                padding: "8px 12px",
                                backgroundColor: "#007bff",
                                borderRadius: "5px",
                                cursor: "pointer",
                                display: "inline-block",
                                //   marginBottom: "20px",
                                border: `1px solid ${selectedBorderColor}`,
                                background: `${selectedButtonBackgoundColors}`,
                                width: "150px",
                                color: `${selectedButtonColors}`,
                                
                            }}
                        >
                            {ischangeImageButtonClicked  ? " Upload Image" : "Change Image"}
                        </label> */}
                    </div>

{!ischangeImageButtonClicked && 
                    <input
                    type="file"
                    id="upload-logo"
                    style={{ display: "none" }}
                    onChange={imageHandler}
                    />
                }
                    {/* <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                            setWorkshopImageFile(e.target.files[0])
                        }
                    /> */}
                    {/* <button    style={{
                        padding: "10px 25px",
                        borderRadius: "20px",
                        background: `${selectedButtonBackgoundColors}`,
                        color: `${selectedButtonColors}`,
                        border: `1px solid ${selectedBorderColor}`,
                    }}>Upload</button> */}
                </div>
                {/* Workshop image ends */}
                <div style={{ display: "flex", gap: "20px", width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Workshop Administrator Name
                        </label>
                        <input
                    disabled

                            placeholder="Workshop administration name..."
                            value={adminNameValue}
                            onChange={(e) => setAdminNameValue(e.target.value)}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Workshop Administrator Username
                        </label>
                        <input
                    disabled

                            placeholder="Workshop administrator username"
                            value={adminUsernameValue}
                            onChange={(e) =>
                                setAdminUsernameValue(e.target.value)
                            }
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", gap: "20px", width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Administrator Email
                        </label>
                        <input
                    disabled

                            placeholder="Administrator email..."
                            value={adminEmailValue}
                            onChange={(e) => setAdminEmailValue(e.target.value)}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Mobile Number
                        </label>
                        <input
                    disabled

                            placeholder="Mobile number..."
                            value={adminPhoneValue}
                            onChange={(e) => setAdminPhoneValue(e.target.value)}
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: "5px",
                        }}
                    >
                        <label
                            className="required"
                            style={{
                                fontSize: "15px",
                                color: "#626262",
                                font: "caption",
                                padding: "0 10px",
                            }}
                        >
                            Escalation Mobile Number
                        </label>
                        <input
                    disabled

                            placeholder="Escalation mobile number"
                            value={escalationPhoneValue}
                            onChange={(e) =>
                                setEscalationPhoneValue(e.target.value)
                            }
                            style={{
                                borderRadius: "24px",
                                padding: "10px",
                                border: "0.5px solid #BFBFBF",
                                background: "rgb(248, 233, 227)",
                            }}
                        />
                    </div>
                </div>

                {/* <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                    <label style={{fontSize: "15px", color: "#626262", font: "caption"}}>Service type</label>
                                       <input value={addressValue} onChange={(e) => setAddressValue(e.target.value)} style={{borderRadius: "24px", padding: "10px", border: "0.5px solid #BFBFBF"}}/>

                </div> */}

{workshopInfoData?.status === "pending"&& 
                
                <div
                    style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: "10px",
                    }}
                >
                    <button
                        className="btn btn-secondary"
                        style={{ borderRadius: "20px" }}
                        onClick={rejectHandler}
                    >
                        Reject
                    </button>
                    <button
                        style={{
                            padding: "10px 25px",
                            borderRadius: "20px",
                            background: `${selectedButtonBackgoundColors}`,
                            color: `${selectedButtonColors}`,
                            border: `1px solid ${selectedBorderColor}`,
                        }}
                        onClick={onboardWorkshophandler}
                    >
                        {loader ? <>Approving...<Loader /></> : "Approve"}
                    </button>
                </div>
}
            </div>

        <div>

            <iframe
  width="100%"
  height="300"
  style={{ border: 0 }}
  loading="lazy"
  allowFullScreen
  src={`https://www.google.com/maps?q=${workshopInfoData?.latitude},${workshopInfoData?.longitude}&z=15&output=embed`}
/>
            </div> 
        </div>
    );
};

export default WorkshopInfo;




